<template>
  <div class="now">
    <app-page-title>De Filme san grod beliebt...</app-page-title>

    <app-loader v-if="loading && page === 1" />

    <app-card :items="getMovies" />

    <v-container v-if="getMovies.pages !== page && getMovies.movies.length !== 0">
      <v-layout row>
        <v-flex>
          <div class="text-xs-center">
            <v-btn
              flat
              :loading="loading"
              @click="loadMore"
            >
              Mehr
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PageTitle from '../components/PageTitle.vue';
import MovieCard from '../components/MovieCard.vue';

export default {
  components: {
    appPageTitle: PageTitle,
    appCard: MovieCard,
  },
  data() {
    return {
      category: 'popular',
      page: 1,
    };
  },
  computed: {
    ...mapState({
      getMovies(state) {
        return state.quickSearch.popular;
      },
    }),
    loading() {
      return this.$store.getters.loading;
    },
  },
  created() {
    this.$store.dispatch('getResults', { category: this.category });
  },
  methods: {
    loadMore() {
      this.page += 1;
      this.$store.dispatch('getResults', { category: this.category, page: this.page });
    },
  },

};
</script>
